document.addEventListener('alpine:init', () => {
  Alpine.data('ProductForm', () => ({
    formEl: null,
    submitting: false,
    init() {
      this.formEl = this.$root.querySelector('form');

      this.formEl.addEventListener('submit', this.submit.bind(this));
    },
    getQuantityBreakerSelection(form) {
      const productRoot = form.closest('[data-product-root]');
      const wrapper = (productRoot && productRoot.querySelector('[data-quantity-breaker]')) || form.querySelector('[data-quantity-breaker]') || document.querySelector('[data-quantity-breaker]');
      if (!wrapper) return null;
      const active = wrapper.querySelector('.quantity-breaker-item--active');
      if (!active) return null;
      const qty = parseInt(active.getAttribute('data-qty') || '1', 10);
      const discount = parseInt(active.getAttribute('data-discount') || '0', 10);
      return { qty, discount };
    },

    syncQuantityBreakerToForm(form) {
      const sel = this.getQuantityBreakerSelection(form);
      if (!sel) return;
      const { qty, discount } = sel;
      form.querySelectorAll('input[name="quantity"]').forEach(function(inp) {
        inp.value = String(qty);
      });
      const formId = form.getAttribute('id');
      if (formId) {
        document.querySelectorAll('input[name="quantity"][form="' + formId + '"]').forEach(function(inp) {
          inp.value = String(qty);
        });
      }
      let tierInput = form.querySelector('input[name="properties[_qb_tier]"]');
      if (!tierInput) {
        tierInput = document.createElement('input');
        tierInput.type = 'hidden';
        tierInput.name = 'properties[_qb_tier]';
        form.appendChild(tierInput);
      }
      tierInput.value = String(qty);
      let discInput = form.querySelector('input[name="properties[_qb_discount]"]');
      if (!discInput) {
        discInput = document.createElement('input');
        discInput.type = 'hidden';
        discInput.name = 'properties[_qb_discount]';
        form.appendChild(discInput);
      }
      discInput.value = String(discount);
    },

    async submit(event) {
      event.preventDefault();
      if (this.submitting) return;
      this.submitting = true;

      this.syncQuantityBreakerToForm(event.target);

      this.$root.dispatchEvent(
        new CustomEvent('baseline:productform:loading', {
          bubbles: true,
        })
      );

      liveRegion(window.theme.strings.loading);

      const formData = new FormData(event.target);
      const formId = event.target.getAttribute('id');
      const qbSel = this.getQuantityBreakerSelection(event.target);
      if (qbSel) {
        formData.set('quantity', String(qbSel.qty));
        formData.set('properties[_qb_tier]', String(qbSel.qty));
        formData.set('properties[_qb_discount]', String(qbSel.discount));
      }

      const options = fetchConfigDefaults('application/javascript');

      formData.append('sections', 'cart-items,cart-footer,cart-item-count');
      formData.append('sections_url', window.location.pathname);

      options.body = formData;
      options.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete options.headers['Content-Type'];

      let response, data;

      response = await fetch(`${theme.routes.cart_add_url}`, options);
      data = await response.json();

      if (data.status) {
        let errors = data.errors || data.description;
        let message = data.description || data.message;

        const errorDetail = {
          sourceId: formId,
          variantId: Number(formData.get('id')),
          errors,
          message,
        };

        this.$root.dispatchEvent(
          new CustomEvent('baseline:productform:error', {
            detail: errorDetail,
            bubbles: true,
          })
        );

        const formEl = this.formEl;
        const productRootEl = formEl.closest('[data-product-root]') || null;

        document.dispatchEvent(
          new CustomEvent('theme:product:error:add-to-cart', {
            detail: {
              productRootEl,
              formEl,
              ...errorDetail,
            },
          })
        );
        this.submitting = false;
        return;
      } else {
        this.$root.dispatchEvent(
          new CustomEvent('baseline:productform:success', {
            bubbles: true,
          })
        );

        document.body.dispatchEvent(
          new CustomEvent('baseline:cart:afteradditem', {
            bubbles: true,
            detail: {
              response: data,
              sourceId: formId,
            },
          })
        );
      }
      this.submitting = false;
    },
  }));
});
